export const isPatient = user => user?.account_type === "patient";
export const isDoctor = user => user?.account_type === "doctor";
export const isReceptionist = user => user?.account_type === "receptionist";
